export default __webpack_public_path__ + "static/form-thank-you-smiley-a43c3b4e7234b624b4f93d015fbdbdbf.webp";